import { gql } from '@apollo/client';

export const PLAYER_BY_ENTRY_TOKEN = gql`
    query playerByEntryToken($token: String!, $pin: String!) {
        playerByEntryToken(token: $token, pin: $pin) {
            _id
            first_name
            last_name
            email
            entry_at
            confirmed
            sub_event_name
            event_name
            event_type
            tracking_number
            emp_player_url
            custom_fields {
                name
                label
                value
                type
            }
            product_variants {
                sku
                price
                attributes {
                    option_name_locale
                    attribute_name_locale
                }
                product {
                    id
                    name
                }
            }
        }
    }
`;
